// Identifies the Microbiome Age submetric by gut_vaginal_health.category_key.
export const MICROBIOME_AGE_CATEGORY_KEY = 'microbiome_age';
// Builds the 4-band array RangesGraph consumes from a single
// microbiome_age_evaluation_ranges row plus the metric's scale-bar edges.
//
// Bands (per science team's front-end data guide):
//   green:  [scaleBarMin, lower_bound)  → Low
//   grey:   [lower_bound, mid_bound)    → Typical
//   orange: [mid_bound,  upper_bound)   → Borderline High
//   red:    [upper_bound, scaleBarMax]  → High
export function buildMicrobiomeAgeBands(row, scaleBarMin, scaleBarMax) {
    const lower = Number(row.lower_bound);
    const mid = Number(row.mid_bound);
    const upper = Number(row.upper_bound);
    const base = {
        name: 'Microbiome age',
        sci_version: row.version,
        gut_vaginal_health_id: row.sex === 'M' ? 980 : 981,
    };
    return [
        {
            ...base,
            id: 'microbiome-age-low',
            evaluation_color: 'green',
            range_lower: scaleBarMin,
            range_upper: lower,
        },
        {
            ...base,
            id: 'microbiome-age-typical',
            evaluation_color: 'grey',
            range_lower: lower,
            range_upper: mid,
        },
        {
            ...base,
            id: 'microbiome-age-borderline-high',
            evaluation_color: 'orange',
            range_lower: mid,
            range_upper: upper,
        },
        {
            ...base,
            id: 'microbiome-age-high',
            evaluation_color: 'red',
            range_lower: upper,
            range_upper: scaleBarMax,
        },
    ];
}
//# sourceMappingURL=buildMicrobiomeAgeBands.js.map